import React, { useState, useEffect } from "react";
import Select from 'react-select';
import axiosConn from "config/axiosConn";
import { FormGroup, Row, Col } from "reactstrap";
import Langfield from "../../assets/Json/eventAssignment.json";
import SideBar from "./SideBar";
import { toast } from "react-toastify";
import { useDispatch } from 'react-redux';
import { FaBarsStaggered } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import CustomDropdown from "./CustomDropdownManagement";
import { Pagination } from 'react-bootstrap';
// Custom dropdown styles
const customStyles = {
  menuList: (provided) => ({
    ...provided,
    maxHeight: 200,
  }),
};

function CreateTheme() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [openSidebar, setOpenSidebar] = useState(false);
  const [events, setEvents] = useState([]); // Store events
  const [registeredFaculties, setRegisteredFaculties] = useState([]);
  const [selectedFaculty, setSelectedFaculty] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState({});
  const [role, setRole] = useState('');

  const [udise_id, setUDISE] = useState();
  const [school_name, setSchoolName] = useState();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const userData = useSelector(state => state.auth.user);
  const langSelected = userData.lang;
  const translations = Langfield[langSelected];
  const translate = (key) => {
    // Check if translations is defined and is an object
    if (typeof translations !== 'object' || translations === null) {
      return key; // Return the key if translations is not available
    }
    // Handle undefined or non-string keys
    if (typeof key !== 'string') {
      return key; // Return the value as is if key is not a string
    }

    return translations[key] || key.replace(/_/g, ' '); // Use translation or fallback to the key
  };
  const handleSelectChangeTheme = (event) => {
    const data = {
      theme_id: event._id,
      theme_name: event.event_name,
    };
    setSelectedEvent(data);
  };

  const handleSelectFacultyChange = (selectedOptions) => {
    setSelectedFaculty(selectedOptions);
  };

  const getThemes = async (data) => {
    try {

      let response = await axiosConn('post', "get-themes", data, {}, dispatch);
      if (response.data.status === "success") {
        setEvents(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Fetch registered faculties
  const getFaculties = async (data) => {
    try {
      let response = await axiosConn('post', "get-registered-faculties", data);
      if (response.data.status === "success") {
        setRegisteredFaculties(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const facultyOptions = registeredFaculties && registeredFaculties.map((item) => ({
    value: item._id,
    teacher_id: item.teacher_id,
    faculty_email: item.email,
    label: `Faculty-ID (${item.teacher_id}) - ${item.teacher_name}`,
  }));
  const [isEmpty, setIsEmpty] = useState(false);
  const HandleAssignEvent = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      if (selectedEvent && selectedFaculty.length > 0) {
        const facultyEmails = selectedFaculty.map(faculty => faculty.faculty_email);
        let postdata = selectedEvent;
        postdata['assigned_teacher'] = facultyEmails;
        postdata['udise_id'] = udise_id;

        const response = await axiosConn('post', 'assign-task', postdata);
        if (response.data.status === 'success') {
          toast.success('Assigned Successfully.');
          setIsSubmitting(false);
          setIsEmpty(true);
          setSelectedFaculty([]);
          setSelectedEvent({});
          // setEvents(events.filter(event => event._id !== selectedEvent.theme_id));
          // navigate("/school/eventlist");
        }
      } else {
        toast.warning('Please select an event and at least one faculty.');
      }
    } catch (error) {
      setIsSubmitting(false);
      console.log(error);
    }
  };
  const label = document.querySelector('.dropdown__filter-selected')
  const options = Array.from(document.querySelectorAll('.dropdown__select-option'))

  options.forEach((option) => {
    option.addEventListener('click', () => {
      label.textContent = option.textContent
    })
  })

  // Close dropdown onclick outside
  document.addEventListener('click', (e) => {
    const toggle = document.querySelector('.dropdown__switch')
    const element = e.target

    if (element == toggle) return;

    const isDropdownChild = element.closest('.dropdown__filter')

    // if (!isDropdownChild) {
    //   toggle.checked = false
    // }
  })
  const handleSidebar = () => {
    setOpenSidebar(!openSidebar);
  }

  // Fetch themes (events) and registered faculties
  useEffect(() => {
    if (userData) {
      getThemes({ udise_id: userData.udise_id });
      getFaculties({ udise_id: userData.udise_id, isActive: true, limit: 1000 });
      setUDISE(userData.udise_id);
      setSchoolName(userData.school_name);
      setRole(userData.role);
    }
  }, [userData]);

  // Check for events that already have assigned faculty
  const eventsWithFacultyAssigned = events.filter(event => event.assigned_teacher && event.assigned_teacher.length > 0);
  const [currentPage, setCurrentPage] = useState(1);
  const [postPerPage, setPostPerPage] = useState(5);
  const lastPostIndex = currentPage * postPerPage;
  const firstPostIndex = lastPostIndex - postPerPage;
  const c_post = eventsWithFacultyAssigned?.slice(firstPostIndex, lastPostIndex);
  const total_page = Math.ceil(eventsWithFacultyAssigned?.length / postPerPage);
  const page_arr = [...Array(total_page).keys()];
  return (
    <section className="scholdashbrdSec">
      <div className="desktopView" style={{ marginTop: 70, textAlign: "end" }}>
        <Link className="button green bars" onClick={handleSidebar}><FaBarsStaggered size={20} /></Link>
      </div>
      <div className={`sidebar ${openSidebar ? "open" : "hideen"}`}>
        <SideBar langSelected={langSelected} index={5} role={role} />      </div>
      <div className="schlDashbrdRgt">
        <div class="row">
          <div class="col-md-12 ">
            <div class="card-user pageContainer pageEventAssignment">
              <div class="card-header pgHederSpceArnd">
                <h5 class="card-title text-center">{translate("Event_Assignment")}</h5>
              </div>
              <div class="card-body">
                <Row>
                  <Col md="5"><FormGroup>UDISE Code: <p>{udise_id}</p></FormGroup></Col>
                  <Col md="6">
                    <FormGroup>{translate("School_Name")}: <p>{school_name}</p></FormGroup>
                  </Col>
                  <Col md="5" sm={12} xs={12}>
                    <FormGroup style={
                      {

                        height: '10%',

                      }
                    }>               <label>{translate("List_of_Events")}</label>
                      <CustomDropdown
                        data={events.filter(event => event.status === 1)}


                        handleSelectChangeTheme={handleSelectChangeTheme}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="5">
                    <FormGroup>
                      <label>{translate("Registered_Faculty")}</label>
                      <Select id="facultySelect" isMulti value={selectedFaculty} onChange={handleSelectFacultyChange} options={facultyOptions} className="basic-multi-select" classNamePrefix="select" styles={customStyles}
                      />

                    </FormGroup>
                  </Col>
                  <Col md="2">
                    <div className="mt-4">
                      <button className="btn mt-2" disabled={isSubmitting || selectedFaculty.length === 0} onClick={HandleAssignEvent}>
                        {translate("Assign_Event")}
                      </button>
                    </div>
                  </Col>
                </Row>

                {eventsWithFacultyAssigned.length > 0 && (
                  <div className="mt-4">
                    <h5>{translate("Events with Assigned Faculty")}</h5>
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Event Name</th>
                          <th>Assigned Faculty</th>
                        </tr>
                      </thead>
                      <tbody>
                        {c_post.map((event, index) => (
                          <tr key={index}>
                            <td>{event.event_name} - {event.theme_name}
                              {event.number_events > 1 && event.event_index && (
                                <span style={{ fontSize: '0.85em', color: '#666', marginLeft: '5px' }}>
                                  (#{event.event_index})
                                </span>
                              )}
                            </td>
                            <td>
                              {(event.assigned_teacher || []).map((teacher, idx) => (
                                <div key={idx}>{teacher ? teacher.replace(/\[at\]/g, '@').replace(/\[dot\]/g, '.') : '-'}</div>
                              ))}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {eventsWithFacultyAssigned ? (
                      <div className="d-flex justify-content-center">
                        <Pagination>
                          {page_arr.map((i, x) => (
                            <Pagination.Item key={i} onClick={() => {
                              setCurrentPage(i + 1);
                            }}
                              active={i + 1 === currentPage}>
                              {i + 1}
                            </Pagination.Item>
                          ))}
                        </Pagination>
                      </div>
                    ) : <></>}

                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CreateTheme;
